import React from 'react'
import {
  InputHLPure,
  ButtonHLPure,
  TextAreaHLPure,
  DropDownBtnHLPure,
  InputSwitchHLPure,
} from '../../pures'
import { useTranslation } from 'react-i18next'

const AdministrationTypeDocumentForm = ({
  viewMode,
  inputValue,
  selectPage,
  handleSubmit,
  handleCancel,
  setInputValue,
  setSelectPage,
  textAreaValue,
  setTextAreaValue,
  dataProfileOptions,
  dataProfileSelected,
  setDataProfileSelected,
  selectedAlert,
  analyzeAI,
  setAnalyzeAI,
}) => {
  const { t } = useTranslation()

  const CHARACTER_LIMIT = 128

  const dropdownOptions = [
    { value: process.env.REACT_APP_DIGITAL_VAULT_DOCUMENT, name: t('configuration.AdministrationTypeDocuments.new.document') },
    { value: process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE, name: t('configuration.AdministrationTypeDocuments.new.file') }
  ]

  return (
    <div className='administrationTypeDocumentForm-container'>
      <div className='administrationTypeDocumentForm-elements'>
        <InputHLPure
          required
          inputActive
          typeInput='text'
          characterLimit={CHARACTER_LIMIT}
          valueInput={inputValue}
          handleChangeInput={(e) => setInputValue(e.target.value)}
          labelInput={t('configuration.AdministrationTypeDocuments.inputLabel.name')}
        />
        <DropDownBtnHLPure
          required
          disable={selectedAlert?.id}
          tooltipShow
          valueItem={'value'}
          nameOption={'name'}
          optionsValue={selectPage}
          optionsDropDown={dropdownOptions}
          onDropDownChange={(e) => setSelectPage(e.target.value)}
          labelDropDown={t('configuration.AdministrationTypeDocuments.inputLabel.type')}
        />
        <DropDownBtnHLPure
          required
          tooltipShow
          valueItem={'key'}
          nameOption={'name'}
          optionsValue={dataProfileSelected}
          optionsDropDown={dataProfileOptions}
          onDropDownChange={(e) => setDataProfileSelected(e.target.value)}
          labelDropDown={t('configuration.AdministrationTypeDocuments.inputLabel.data.profile')}
        />
        {selectPage === 'Documento' && (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <label className="inputHLPure-label" >
              {t('configuration.AdministrationTypeDocuments.inputLabel.ai.analysis')}
            </label>
            <InputSwitchHLPure
              checked={analyzeAI}
              onChange={(e) => setAnalyzeAI(e.value)}
            />
          </div>
        )}
        <TextAreaHLPure
          tooltipShow
          valueTextData={textAreaValue}
          handleChangeTextArea={(e) => setTextAreaValue(e.target.value)}
          labelTextArea={t('configuration.AdministrationTypeDocuments.inputLabel.description')}
        />
        <div className='administrationTypeDocumentForm-btns'>
          <ButtonHLPure
            onClickBtn={handleCancel}
            nameBtn={t('configuration.AdministrationTypeDocuments.button.cancel')}
          />
          <ButtonHLPure
            primary
            nameBtn={t('configuration.AdministrationTypeDocuments.button.save')}
            onClickBtn={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default AdministrationTypeDocumentForm
